import {EntityType} from './document';

/**
 * Nodo de la jerarquia que acompana a la notificacion, de lo mas concreto a lo
 * mas general: documento > servicio > proyecto.
 */
export interface NotificationPathNode {
  id: number;
  name: string;
  parent?: NotificationPathNode;
}

export interface Notification {
  id: number,
  isRead: boolean,
  subject: string,
  body: string,
  entityType: EntityType,
  entityId: number,
  userId: number,
  createdOn: string,
  modifiedOn: string,
  /**
   * DocumentsToValidate lo emiten varios origenes con significados distintos
   * (documento subido y asignacion con documentos sin validar), por lo que su
   * texto se toma de subject/body y no se fija en la UI. DocumentValidated es
   * la aprobacion, que desde Sourtrack.Database 2026.8.17.3 tiene tipo propio.
   * EquipmentAssigned es el respaldo cuando el correo de asignacion no sale.
   *
   * OrderPendingStep y OrderRejected (SOU-481) los emite finance al ejecutarse un paso
   * del flujo de firmas de un EP o una OC: avisan a quien le toca actuar despues. Su
   * texto lo redacta el backend en subject/body, igual que los de documento.
   */
  notificationType: 'Undefined' | 'MentionInChat' | 'MissingRequiredDocuments'|'DocumentsToValidate'
    |'DocumentRejected'|'ProjectDateChanged'|'ProjectAdjudicated'|'AssignedToProject'
    |'EquipmentAssigned'|'DocumentValidated'|'OrderPendingStep'|'OrderRejected',
  path?: NotificationPathNode;

  /** Autor de la accion que origina la notificacion. */
  user?: {
    id?: number,
    partner?: {id: number, name: string, surName?: string, avatar?: string},
  };

  oldDate?: string;
  newDate?: string;
  missingDocuments?: {docType: string, entityType: EntityType, entityId: number}[];
  project: {id: number, name: string},
  service?: {id: number, name: string},
  documents?: {id: number, name: string, type: string}[],
  partner?: {id: number, name: string, avatar: string},
  chatId?: number,
}
